export default __webpack_public_path__ + "static/media/RMS-OpeningOpening_PatientCaseStudy_BPIDfromMDD_V2_Still.369d94ff.png";